import Page500 from "./components/500";

export default Page500;
